<div class="row text-center dark text-white my-auto mx-auto" style="height: 100%; align-items: center;">
    <div class="col-md-12">
        <h2>404 | Page Not Found</h2>
        <button class="btn btn-utility" routerLink="/">Go to HOME</button>
    </div>
</div>